// Module
var code = `<button data-event-type="externalLink" data-link="{{info.link}}">
  <svg
    width="18pt"
    height="18pt"
    version="1.1"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M 11.964 14.011 L 13.404 14.011 C 13.802 14.011 14.124 13.689 14.124 13.291 L 14.124 3.451 C 14.124 3.054 13.802 2.731 13.404 2.731 L 5.004 2.731 C 4.607 2.731 4.284 3.054 4.284 3.451 L 4.284 4.891 L 2.844 4.891 C 2.447 4.891 2.124 5.214 2.124 5.611 L 2.124 15.451 C 2.124 15.849 2.447 16.171 2.844 16.171 L 11.244 16.171 C 11.642 16.171 11.964 15.849 11.964 15.451 L 11.964 14.011 Z M 5.004 3.211 C 4.872 3.211 4.764 3.319 4.764 3.451 L 4.764 4.891 L 11.244 4.891 C 11.642 4.891 11.964 5.214 11.964 5.611 L 11.964 13.531 L 13.404 13.531 C 13.536 13.531 13.644 13.423 13.644 13.291 L 13.644 3.451 C 13.644 3.319 13.536 3.211 13.404 3.211 L 5.004 3.211 Z M 2.604 5.611 C 2.604 5.479 2.712 5.371 2.844 5.371 L 11.244 5.371 C 11.376 5.371 11.484 5.479 11.484 5.611 L 11.484 15.451 C 11.484 15.583 11.376 15.691 11.244 15.691 L 2.844 15.691 C 2.712 15.691 2.604 15.583 2.604 15.451 L 2.604 5.611 Z"
      fill="#fff"
      fill-rule="evenodd"
    />
  </svg>
</button>
`;
// Exports
module.exports = code;